(function() {
  function matchDescriptionWidth() {
    var buttons = document.querySelectorAll('.product-form__submit');
    if (!buttons.length) return;

    buttons.forEach(function(button) {
      var rect = button.getBoundingClientRect();
      var targetWidth = rect.width;
      if (!targetWidth || targetWidth < 10) return;

      var container = button.closest('.product__info-container') || button.closest('section') || document;
      var description = container.querySelector('.product__description');
      if (!description) return;

      description.style.setProperty('width', targetWidth + 'px', 'important');
      description.style.setProperty('max-width', targetWidth + 'px', 'important');
      description.style.setProperty('box-sizing', 'border-box', 'important');
      description.style.setProperty('word-break', 'break-word', 'important');
      description.style.setProperty('overflow-wrap', 'anywhere', 'important');

      var paragraphs = description.querySelectorAll('p, li, ul');
      paragraphs.forEach(function(el) {
        el.style.setProperty('width', '100%', 'important');
        el.style.setProperty('max-width', '100%', 'important');
        el.style.setProperty('box-sizing', 'border-box', 'important');
        el.style.setProperty('word-break', 'break-word', 'important');
        el.style.setProperty('overflow-wrap', 'anywhere', 'important');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', matchDescriptionWidth);
  window.addEventListener('load', matchDescriptionWidth);
  window.addEventListener('resize', matchDescriptionWidth);
  setTimeout(matchDescriptionWidth, 100);
  setTimeout(matchDescriptionWidth, 300);
  setTimeout(matchDescriptionWidth, 800);
  setTimeout(matchDescriptionWidth, 1500);
  setTimeout(matchDescriptionWidth, 3000);
})();
